<template>
    <div class="input-rating" v-bind:class="[ isEditable ? 'editable' : '', isFillable ? 'fillable' : '' ]">
        <div  v-for="(item,index) in rating" class="flex-center">
            <div class="field">
               <label v-if="inputLabel[index] != '' && !isEditable">
                   <span v-html="inputLabel[index]"></span>
               </label>
                <input v-bind:name="inputName" v-bind:placeholder="inputPlaceholder" class="small" type="text" v-model="inputLabel[index]" v-if="isEditable" @keyup="checkForEmpty" />
            </div>

            <div class="flex-filler"></div>

            <div class="rating" v-bind:class="inputLevel[index]">
                <span v-for="i in ratingRange" @mouseover="hover(index,i)" @mouseleave="blur(index)" @click="setRating(index,i)">
                    <span class="material-icons active" v-if="i <= item" v-html="iconActive"></span>
                    <span class="material-icons inactive" v-if="i > item" v-html="iconInactive"></span>
                </span>
                <span class="rating-selection txt" v-bind:class="inputLevel[index]" v-if="keys && keys.length > 1">
                    {{ keys[inputRatingSelection[index] - 1] }}
                </span>
                <input v-bind:name="inputRatingName" v-model="inputRating[index]" type="hidden" />
            </div>
        </div>
    </div>
</template>


<script>
    module.exports = {
        created: function () {
            if (this.icon != undefined){

                if (this.icon[0] != undefined){
                    this.iconActive = this.icon[0];
                }

                if (this.icon[1] != undefined){
                    this.iconInactive = this.icon[1];
                } else if (this.icon[0] != undefined){
                    this.iconInactive = this.icon[0];
                }
            }

            if (this.range != undefined){
                this.ratingRange = parseFloat(this.range);
            }

            if (this.name != undefined){
                this.inputName = this.name;
            }

            if (this.placeholder != undefined) {
                this.inputPlaceholder = this.placeholder;
            }

            if(this.editable != undefined) {
                this.isEditable = true;
            }

            if(this.multiple != undefined) {
                this.isMultiple = true;
            }

            if (this.value != undefined){
                this.rating = this.value;
            }

            if(this.label != undefined) {
                this.inputLabel = this.label;
            }

            for(var i=0; i < this.rating.length; i++) {
                this.inputRating.push(this.rating[i]);
                this.setInputLevel(i, this.rating[i]);
            }

            this.inputRatingName = this.inputName + '_rating';

            if(this.isMultiple) {
                this.inputName += '[]';
                this.inputRatingName += '[]';
            }

            this.isFillable = this.fillable;

            this.$forceUpdate();
            this.checkForEmpty();

        },
        data:function() {
            return {
                iconInactive: 'radio_button_unchecked',
                iconActive: 'radio_button_checked',
                ratingRange: 5,
                rating: [0],
                inputRating: [],
                inputRatingSelection:[],
                inputName: 'rating',
                inputLevel:[],
                inputRatingName:'',
                inputPlaceholder:'',
                inputLabel:[''],
                isEditable:false,
                isFillable:false,
                isMultiple:false
            }
        },
        props: {
            icon:{type:Array},
            range:{type:String},
            value:{type:Array},
            name:{type:String},
            label:{type:Array},
            editable:{type:String},
            fillable:{type:Boolean,default:false},
            multiple:{type:String},
            keys:{type:Array},
            placeholder:{type:String}
        },
        methods: {
            hover:function (index,rating) {
                if(this.isEditable || this.isFillable) {
                    this.rating[index] = rating;
                    this.inputRatingSelection[index] = rating;
                    this.$forceUpdate();
                    this.setInputLevel(index, rating);
                }
            },
            blur:function (index) {
                if(this.isEditable || this.isFillable) {
                    this.rating[index] = this.inputRating[index];
                    this.inputRatingSelection[index] = this.inputRating[index];
                    this.$forceUpdate();
                    this.setInputLevel(index, this.rating[index]);
                }
            },
            setInputLevel:function (index, rating) {
                if(rating > 4) {
                    this.inputLevel[index] = 'max';
                } else  if(rating > 3) {
                    this.inputLevel[index] = 'high';
                } else if(rating > 2) {
                    this.inputLevel[index]  = 'medium';
                } else {
                    this.inputLevel[index]  = 'low';
                }
            },
            setRating:function (index,rating) {
                if(this.isEditable || this.isFillable) {
                    this.rating[index] = rating;
                    this.inputRating[index] = rating;
                    this.$forceUpdate();
                    this.setInputLevel(index, rating);
                }
            },
            checkForEmpty:function() {
                if(this.isEditable) {
                    var empty = 0;
                    var e = this;
                    for (var i = 0; i < this.inputLabel.length; i++) {
                        if (this.inputLabel[i] == "") {
                            this.inputRating[i] = 0;
                            this.rating[i] = 0;
                            empty += 1;
                        }
                    }
                    if (empty <= 0) {
                        e.rating.push(0);
                        e.inputRating.push(0);
                        e.inputLabel.push("");
                        setTimeout(function () {
                            e.$root.$setModalItemHeight();
                        }, 100);
                    } else if (empty > 1) {
                        var foundEmpty = false;
                        for (var i = this.inputLabel.length; i > 0; i--) {
                            if (!foundEmpty && this.inputLabel[i] == "") {
                                this.$delete(this.inputLabel, i);
                                this.$delete(this.rating, i);
                                this.$delete(this.inputRating, i);
                                foundEmpty = true;
                                setTimeout(function () {
                                    e.$root.$setModalItemHeight();
                                }, 100);
                            }
                        }
                    }
                }
            }

        },
        mounted:function() {

        }
    }
</script>
